export default "__VITE_ASSET__CqKH1k5k__"